import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useRouter } from "next/router";

export default function DataSources({
	open,
	onClose,
	page,
	lastUpdated,
}: {
	open: boolean;
	onClose: () => void;
	page?: string;
	lastUpdated: string;
}) {
	const router = useRouter();
	const admin = () => {
		onClose();
		setTimeout(() => {
			router.push("admin");
		}, 100);
	};
	return (
		<Transition.Root show={open} as={Fragment}>
			<Dialog as="div" className="relative z-50" onClose={onClose}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0">
					<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
				</Transition.Child>

				<div className="fixed inset-0 z-50 overflow-y-auto">
					<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
							<Dialog.Panel className="relative w-full transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:max-w-sm sm:p-6">
								<div>
									<div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-cary-100">
										<InformationCircleIcon className="h-6 w-6 text-cary-400" aria-hidden="true" />
									</div>
									<div className="mt-3 text-center sm:mt-5">
										<Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
											Dashboard Data Sources
										</Dialog.Title>
										<div className="mt-2">
											<p className="text-sm text-gray-500">
												Data Last Updated: <strong>{lastUpdated}</strong> <br />
												Dashboard Last Updated: <strong>11/26/2022</strong> <br />
												Build ID: <strong>{process.env.NEXT_PUBLIC_BUILD_ID}</strong>
												<br />
												{(!page || page !== "Admin") && (
													<button onClick={admin} className="hidden font-semibold text-cary-400 underline hover:no-underline sm:inline-block">
														Admin Login
													</button>
												)}
											</p>
										</div>
									</div>
								</div>
								<div className="mt-4">
									<button
										type="button"
										className="inline-flex w-full justify-center rounded-md border border-transparent bg-cary-400 px-4 py-2 text-base font-medium text-white opacity-80 shadow-sm hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-cary-300 focus:ring-offset-2 sm:text-sm"
										onClick={onClose}>
										Close
									</button>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
}
